module.exports = __webpack_public_path__ + "img/case-ct_capsule_side.3593b23.png";